import { useCallback, useState } from 'react'

type AsyncFunctonWithInput<InputType, ItemType> = (input: InputType) => Promise<ItemType>

export interface UseAsyncOperationReturnType<InputType, ItemType> {
  runFunction: AsyncFunctonWithInput<InputType, ItemType>
  loading: boolean
  item?: ItemType
  errorMessage?: string
}

export function useAsyncOperation<InputType, ItemType> (
  fn: AsyncFunctonWithInput<InputType, ItemType>
): UseAsyncOperationReturnType<InputType, ItemType> {
  const [item, setItem] = useState<ItemType>()
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()

  const runFunction = useCallback(async (input: InputType): Promise<ItemType> => {
    try {
      setLoading(true)
      setErrorMessage(undefined)
      const result = await fn(input)
      setItem(result)
      return result
    } catch (e) {
      if (e instanceof Error) {
        setErrorMessage(e.message)
      }
      throw e
    } finally {
      setLoading(false)
    }
  }, [fn])

  return {
    runFunction,
    item,
    loading,
    errorMessage
  }
}
